import React from "react";
import ModelCollectionItem from "@/components/collection/ModelCollectionItem";
const ModelCollectionsWithVoice = ({ collections }) => {
  return (
    <div className="tw-w-full tw-flex tw-flex-col tw-mt-16">
      <div className="tw-font-bold tw-text-xl tw-w-full tw-mb-3">
        Collections With This Voice
      </div>
      <div className="tw-w-full tw-flex  tw-gap-4 tw-overflow-x-scroll tw-pb-6 tw-overflow-y-visible tw-scrollbar-thin tw-scrollbar-thumb-transparent">
        {collections?.map((collection, idx) => (
          <ModelCollectionItem
            key={collection._id}
            collection={collection}
            idx={idx}
          />
        ))}
      </div>
    </div>
  );
};

export default ModelCollectionsWithVoice;
